import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth/withWidth';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography/Typography';
import Grid from '@material-ui/core/Grid/Grid';
import RadioGroup from '@material-ui/core/RadioGroup/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Radio from '@material-ui/core/Radio/Radio';
import FormControl from '@material-ui/core/FormControl/FormControl';
import Icon from '@material-ui/core/Icon/Icon';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LoopIcon from '@material-ui/icons/Loop';
import ColorizeIcon from '@material-ui/icons/Colorize';
import FormatPaintIcon from '@material-ui/icons/FormatPaint';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import PhotoLibrary from '@material-ui/icons/PhotoLibrary';
import AddBox from '@material-ui/icons/AddBox';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import MessageBox from '@configuratorware/configurator-frontendgui/App/Shared/Components/MessageBox';

import Dialog from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Components/Dialog';
import ColorPicker from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Components/ImageColorPicker/ImageColorPicker';
import ImageThumbnail from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Components/ImageEditDialog/ImageThumbnail';
import colorizeIcon from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Components/ImageEditDialog//res/baseline_colorize_black_24dp.png';
import checkers from '@configuratorware/configurator-frontendgui/App/Modules/Designer/Components/ImageEditDialog//res/checkers_tile.png';
import MobileMenuStep from '../../../../Shared/Components/MobileMenuStep';

const styles = (theme) => ({
  dialogContent: {
    '&:first-child': {
      [theme.breakpoints.down('sm')]: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 40,
      padding: '8px 0 8px 24px',
      '&.color-preview-block': {
        marginBottom: 0,
      },
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 24,
      padding: 0,
    },
  },
  dialogWrapper: {
    "& .MuiDialogTitle-root":{
      "& .MuiIcon-root":{
        borderRadius: 100,
    padding: 4,
    marginTop: -4,
    marginRight: -4,
    "&:hover":{
      boxShadow: 'none',
      background: "#F2F2F2"
    },
    "&:active, &:focus":{
      boxShadow: 'none',
      background: "#C9C9C9"
    },
      }
    },
    maxWidth: '1000px',
    borderTop: `7px solid ${theme.palette.primary.main}`,
    padding: '0px 24px 16px 8px',
    overflowX: 'hidden',

    [theme.breakpoints.down('xs')]: {
      padding: 0,
      '& .MuiDialogTitle-root': {
        padding: theme.smallScreen.padding,
      },
    },
  },
  imageUploadSpacing: {
    backgroundColor: 'white',
    [theme.breakpoints.down('sm')]: {
      bottom: 24,
      left: 0,
      right: 0,
      padding: '0 24px 8px',
      position: 'absolute',
    },
    [theme.breakpoints.down('xs')]: {
      bottom: 4,
      padding: 0,
    },
  },
  PreviewDialogButton: {
    fontSize: 15,
    minWidth: 140,
    height: 40,
    '&:disabled': {
      backgroundColor: '#DDDDDD',
      '& span': {
        color: '#C4C4C4',
      },
    },

    '& input': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      opacity: 0,

      '&:hover': {
        cursor: 'pointer',
      },
    },
    [theme.breakpoints.down('xs')]: {
      height: 56,
      margin: theme.smallScreen.padding,
    },
  },
  imageTabOptions: {
    '& button': {
      minWidth: '33%',
      minHeight: 64,
      textTransform: 'none',
      fontSize: 15,
      color: '#757575',
    },
  },
  colorizeCaption: {
    color: '#757575',
    display: 'flex',
    alignItems: 'center',
    marginTop: 24,
    '& i': {
      marginLeft: 8,
    },
  },
  PreviewDialogImage: {
    '& canvas': {
      // use the colorize icon as cursor directly
      cursor: `url(${colorizeIcon}) 2 21, auto`,
    },
  },
  PreviewDialogImageColorize: {
    '& canvas': {
      cursor: 'default',
    },
  },
  TabContent: {
    padding: 12,
    maxHeight: 330,
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 2px',
      maxHeight: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px 0px',
    },
  },
  PreviewDialogGridAlign: {
    padding: '20px 24px',
    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
  },
  selectedBackgroundFields: {
    display: 'block',
  },
  imageEditDialogItem: {
    maxWidth: 475,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 16px 8px',
    },
  },
  alignGrid: {
    paddingLeft: 40,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.smallScreen.padding,
      paddingRight: theme.smallScreen.padding,
    },
  },
  rootContainerWrapper: {

    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      flexWrap: 'wrap',
    },
    [theme.breakpoints.down('xs')]: {
      overflowY: 'auto',
    },
  },
  previewImageWrapper: {
    backgroundSize: '24px 24px',
    marginBottom: 82,
    background: `#bebebe url(${checkers})`,
    display: 'flex',
    height: 360,
    width: 450,
    '&.color-preview-block': {
      marginBottom: 8,
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      marginBottom: 0,
    },
    [theme.breakpoints.down('xs')]: {
      overflowY: 'auto',
      flexWrap: 'wrap',
      height: 220,
    },
    '& div:first-child': {
      margin: '5%',
      flex: 1,
      maxHeight: '100%',
      width: '90%',

      '& canvas': {
        display: 'block',
        margin: '0 auto',
      },
    },
  },
  hideTabs: {
    display: 'none',
  },
  imageSelectTab: {
    padding: '24px 16px',
    [theme.breakpoints.down('xs')]: {
      padding: '30px 8px',
    },
  },
  imageSelectTitle: {
    fontWeight: 'bold',
  },
  imageSelectArrowButton: {
    fontSize: 14,
    float: 'left',
    height: 70,
    lineHeight: 70,
    cursor: 'pointer',
    margin: 8,
  },
  imageSelectUploadedImage: {
    '&:first-child': {
      marginLeft: 0,
    },
    width: 70,
    height: 70,
    float: 'left',
    margin: ' 0 10px',
    borderRadius: 8,
    background: '#eee',
    cursor: 'pointer',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      margin: 4,
    },
  },
  imageSelectUploadedImageActive: {
    margin: '0 8px',
    border: '2px solid red',
    [theme.breakpoints.down('xs')]: {
      margin: 4,
    },
  },
  imageSelectButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    width: 250,
    padding: '7px 15px',
    [theme.breakpoints.down('xs')]: {
      height: 56,
      width: '98%',
    },
  },
  iconButton: {
    paddingRight: 8,
    color: theme.palette.primary.darkText,
  },
  imageSelectGrid: {
    [theme.breakpoints.down('xs')]: {
      padding: '8px 0 !important',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  imageTab: {
    [theme.breakpoints.down('xs')]: {
      fontWeight: 'bold',
      fontSize: '13px !important',
    },
  },
  colorPreviewToggleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: 8,
    '&.align-container': {
      marginBottom: 75,
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
      },
    },
  },
  colorSwitchBase: {
    color: theme.designer.imageEditDialog.errorColor,
    '&$colorChecked': {
      color: theme.designer.imageEditDialog.errorColor,
    },
  },
  colorBar: {
    backgroundColor: theme.designer.imageEditDialog.errorColor,
  },
  colorChecked: {},
  errorContainer: {
    color: theme.designer.imageEditDialog.errorColor,
  },
  buttonContent: {
    color: theme.palette.primary.darkText,
  },
  detailList: {
    padding: 0,
  },
});

class ImageEditDialog extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      width: PropTypes.string,
      backgroundSelected: PropTypes.string,
      changeSelectedBackground: PropTypes.func,
      preview: PropTypes.string,
      open: PropTypes.bool,
      closePreviewDialog: PropTypes.func,
      continueClick: PropTypes.func,
      onChangeColor: PropTypes.func,
      colorPickerEnabled: PropTypes.bool,
      imageColorizeElement: PropTypes.element,
      activeTabIndex: PropTypes.number,
      onActiveTabChange: PropTypes.func,
      colorDisabled: PropTypes.bool,
      errorFeedback: PropTypes.element,
      loaderComponent: PropTypes.element,
      continueButtonDisabled: PropTypes.bool,
      image: PropTypes.object,
      userImages: PropTypes.array,
      setSelectedImage: PropTypes.func.isRequired,
      onGalleryClick: PropTypes.func,
      galleryHasImages: PropTypes.bool,
      showWarningMessage: PropTypes.bool,
      displayColorPreview: PropTypes.bool,
      onOriginalImageAndColorPreviewToggleClick: PropTypes.func,
      originalImagePreview: PropTypes.string,
      embroideryNoticeRef: PropTypes.object,
      colorPreviewBlockActive: PropTypes.bool.isRequired,
      colorPreviewRequirementFulfilled: PropTypes.bool.isRequired,
      showUploadPanel: PropTypes.bool.isRequired,
      uploadDisabled: PropTypes.bool.isRequired,
      setUpload: PropTypes.func.isRequired,
      imageUploadElement: PropTypes.element,
      onNewUploadClick: PropTypes.func.isRequired,
      uploadImage: PropTypes.func.isRequired,
      selectUserImage: PropTypes.func.isRequired,
    };

    constructor(props) {
      super(props);

      this.state = {
        userImagesIndex: 0,
      };
    }

    onChangeColor = (color) => {
      const { onChangeColor, activeTabIndex } = this.props;

      onChangeColor && activeTabIndex === 1 && onChangeColor(color);
    };

    onActiveTabChange = (e, newActiveTabIndex) => {
      const { onActiveTabChange } = this.props;
      onActiveTabChange && onActiveTabChange(newActiveTabIndex);
    };

    onSelectedBackgroundChange = (e, value) => {
      const { changeSelectedBackground } = this.props;
      const selectedBackground = value ? 'replace' : null;

      changeSelectedBackground && changeSelectedBackground(selectedBackground);
    };

    changeSelectedBackground = (e, value) => {
      const { changeSelectedBackground } = this.props;

      changeSelectedBackground && changeSelectedBackground(value);
    };

    setUserImagesIndexPrev = () => {
      const { userImagesIndex } = this.state;

      const newIndex = userImagesIndex - 1;

      if (newIndex < 0) {
        return;
      }

      this.setState({ userImagesIndex: newIndex });
    };

    setUserImagesIndexNext = () => {
      const { userImages } = this.props;
      const { userImagesIndex } = this.state;

      const newIndex = userImagesIndex + 1;
      const lastAvailableIndex = userImages.length - 3;

      if (newIndex > lastAvailableIndex) {
        return;
      }

      this.setState({ userImagesIndex: newIndex });
    };

    getWarningMessageText = () => t('imageEditDialog.warningMessage');

    galleryClick = () => {
      const { onGalleryClick } = this.props;
      onGalleryClick && onGalleryClick();
    };

    render() {
      const {
        classes,
        backgroundSelected,
        preview,
        errorFeedback,
        open,
        closePreviewDialog,
        continueClick,
        loaderComponent,
        colorPickerEnabled,
        imageColorizeElement,
        activeTabIndex,
        width,
        colorDisabled,
        image,
        userImages,
        galleryHasImages,
        showWarningMessage,
        displayColorPreview,
        onOriginalImageAndColorPreviewToggleClick,
        originalImagePreview,
        embroideryNoticeRef,
        colorPreviewBlockActive,
        colorPreviewRequirementFulfilled,
        uploadDisabled,
        imageUploadElement,
        onNewUploadClick,
        uploadImage,
        selectUserImage,
        showUploadPanel,
        closeMobilePickerMenu,
        setModalContentOption, modalContentOptions, currentModalContentOption,
      } = this.props;

      const { userImagesIndex } = this.state;

      const userImagesIndexes = [];

      for (let i = userImagesIndex; i < userImages.length && i < userImagesIndex + 3; i++) {
        userImagesIndexes.push(i);
      }

      const showNewUploadArea = showUploadPanel || !image;
      const colorPreviewErrorContainer = `${classes.colorPreviewToggleContainer} ${classes.errorContainer}`;

      const renderDialogContent = () => (
        <DialogContent
          className={`${classes.dialogContent} ${
            colorPreviewBlockActive ? 'color-preview-block' : ''
          }`}
        >
          {loaderComponent}
          <Grid container className={classes.rootContainerWrapper}>
            {showNewUploadArea && (
            <Grid item xs={12} sm={12} className={classes.imageEditDialogItem}>
              {imageUploadElement}
            </Grid>
            )}
            {!showNewUploadArea && (
            <Grid item xs={12} sm={12} className={classes.imageEditDialogItem}>
              {errorFeedback}
              <div
                className={`${classes.previewImageWrapper} ${
                  colorPreviewBlockActive ? 'color-preview-block' : ''
                }`}
              >
                <ColorPicker
                  src={
                                          [0, 2].includes(activeTabIndex)
                                          && !displayColorPreview
                                          && !image.gallery
                                            ? originalImagePreview
                                            : preview
                                      }
                  wrapperClassName={
                                          activeTabIndex === 1
                                            ? classes.PreviewDialogImage
                                            : classes.PreviewDialogImageColorize
                                      }
                  onChange={this.onChangeColor}
                  enabled={activeTabIndex === 1}
                />
              </div>

              {colorPreviewBlockActive && (
              <>
                <div
                  ref={embroideryNoticeRef}
                  className={`${
                    !colorPreviewRequirementFulfilled
                      ? colorPreviewErrorContainer
                      : classes.colorPreviewToggleContainer
                  } ${
                    displayColorPreview && !showWarningMessage
                      ? 'align-container'
                      : ''
                  }`}
                >
                  <Typography>{t('imageEditDialog.originalPicture')}</Typography>
                  <Switch
                    classes={{
                      switchBase: !colorPreviewRequirementFulfilled
                        ? classes.colorSwitchBase
                        : '',
                      checked: !colorPreviewRequirementFulfilled
                        ? classes.colorChecked
                        : '',
                      track: !colorPreviewRequirementFulfilled
                        ? classes.colorBar
                        : '',
                    }}
                    checked={displayColorPreview}
                    onChange={onOriginalImageAndColorPreviewToggleClick}
                    color="primary"
                  />
                  <Typography>{t('imageEditDialog.colorPreview')}</Typography>
                </div>

                {displayColorPreview ? (
                  <>
                    {showWarningMessage && (
                    <MessageBox
                      text={this.getWarningMessageText()}
                      type="warning"
                    />
                    )}
                  </>
                ) : (
                  <MessageBox
                    text={
                                                  !colorPreviewRequirementFulfilled
                                                    ? t('imageEditDialog.pictureEmbroideryHint')
                                                    : t('imageEditDialog.pictureToggleHint')
                                              }
                    type={!colorPreviewRequirementFulfilled ? 'error' : 'warning'}
                  />
                )}
              </>
              )}
            </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={12}
              className={
                              classes.alignGrid
                              + (showUploadPanel && width === 'xs' ? ` ${classes.hideTabs}` : '')
                          }
            >
              <AnalyticsWrapper targetId="image_edit_options">
                <Tabs
                  className={classes.imageTabOptions}
                  value={activeTabIndex}
                  onChange={this.onActiveTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant={!isWidthUp('xs', width) ? 'fullWidth' : 'standard'}
                >
                  <Tab
                    icon={<LoopIcon />}
                    className={classes.imageTab}
                    label={t('imageEditDialog.changeFile')}
                  />
                  <Tab
                    icon={<ColorizeIcon />}
                    className={classes.imageTab}
                    label={t('imageEditDialog.background')}
                    disabled={image && image.gallery}
                  />
                  <Tab
                    icon={<FormatPaintIcon />}
                    className={classes.imageTab}
                    label={t('imageEditDialog.colorize')}
                    disabled={colorDisabled}
                  />
                </Tabs>
              </AnalyticsWrapper>
              {activeTabIndex === 0 && (
              <div className={`${classes.TabContent} ${classes.imageSelectTab}`}>
                <Grid container spacing={2}>
                  {!showNewUploadArea && (
                  <Grid item xs={12} className={classes.imageSelectGrid}>
                    <Typography className={classes.imageSelectTitle}>
                      {t('imageEditDialog.selectFromMyUploads')}
                    </Typography>
                  </Grid>
                  )}
                  {!showNewUploadArea && (
                  <Grid
                    item
                    xs={12}
                    className={classes.imageSelectGrid}
                    style={{
                      justifyContent:
                                                      userImages.length > 3 ? 'space-between' : 'start',
                    }}
                  >
                    {userImages.length > 3 && (
                    <ArrowBackIos
                      className={classes.imageSelectArrowButton}
                      onClick={this.setUserImagesIndexPrev}
                    />
                    )}
                    {userImagesIndexes.map((imageIndex, index) => {
                      const isActive = image
                                                      && userImages[imageIndex].identifier
                                                          === image.identifier;
                      return (
                        <div
                          key={index}
                          className={
                                                              classes.imageSelectUploadedImage
                                                              + (isActive
                                                                ? ` ${
                                                                  classes.imageSelectUploadedImageActive}`
                                                                : '')
                                                          }
                          onClick={() => selectUserImage(imageIndex)}
                        >
                          <ImageThumbnail image={userImages[imageIndex]} />
                        </div>
                      );
                    })}
                    {userImages.length > 3 && (
                    <ArrowForwardIos
                      className={classes.imageSelectArrowButton}
                      onClick={this.setUserImagesIndexNext}
                    />
                    )}
                  </Grid>
                  )}
                  {galleryHasImages && (
                  <Grid item xs={12} className={classes.imageSelectGrid}>
                    <Button
                      onClick={this.galleryClick}
                      variant="outlined"
                      className={classes.imageSelectButton}
                      fullWidth={!isWidthUp('sm', width)}
                    >
                      <PhotoLibrary className={classes.iconButton} />
                      <span className={classes.buttonContent}>
                        {t('imageEditDialog.selectFromGallery')}
                      </span>
                    </Button>
                  </Grid>
                  )}
                  {!showNewUploadArea && (
                  <Grid item xs={12} className={classes.imageSelectGrid}>
                    <Button
                      onClick={onNewUploadClick}
                      variant="outlined"
                      className={classes.imageSelectButton}
                      fullWidth={!isWidthUp('sm', width)}
                    >
                      <AddBox className={classes.iconButton} />
                      <span className={classes.buttonContent}>
                        {t('imageEditDialog.uploadNewImage')}
                      </span>
                    </Button>
                  </Grid>
                  )}
                </Grid>
              </div>
              )}
              {activeTabIndex === 1 && (
              <div className={`${classes.TabContent} ${classes.PreviewDialogGridAlign}`}>
                <FormControl
                  component="fieldset"
                  className={classes.selectedBackgroundFields}
                >
                  <FormControlLabel
                    control={(
                      <Switch
                        checked={backgroundSelected !== null}
                        onChange={this.onSelectedBackgroundChange}
                        color="primary"
                      />
                                            )}
                    label={t('fileUpload.removeBackground')}
                  />
                  <AnalyticsWrapper targetId="image_background">
                    <RadioGroup
                      aria-label="background removement"
                      name="backgroundRemovement"
                      value={backgroundSelected || ''}
                      onChange={this.changeSelectedBackground}
                    >
                      <FormControlLabel
                        value="flood"
                        control={<Radio color="primary" />}
                        label={t('fileUpload.removeBackgroundFromBorder')}
                        disabled={backgroundSelected === null}
                      />
                      <FormControlLabel
                        value="replace"
                        control={<Radio color="primary" />}
                        label={t('fileUpload.removeBackgroundEverywhere')}
                        disabled={backgroundSelected === null}
                      />
                    </RadioGroup>
                  </AnalyticsWrapper>
                </FormControl>
                {colorPickerEnabled && (
                <Typography variant="caption" className={classes.colorizeCaption}>
                  <Icon>colorize</Icon>
                  <i>
                    {t(
                      !isWidthUp('xs', width)
                        ? 'fileUpload.tabColorForRemove'
                        : 'fileUpload.chooseColorForRemove',
                    )}
                  </i>
                </Typography>
                )}
              </div>
              )}
              {activeTabIndex === 2 && (
              <div className={classes.TabContent}>{imageColorizeElement}</div>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      );
      if (!isWidthUp('sm', width)) {
        return (
          <MobileMenuStep
            doDisplayDesignArea={false}
            doDisplay={open}
            renderStep={() => (
              <div className={classes.detailList}>
                {renderDialogContent()}
              </div>
            )}
            heading={showUploadPanel ? t('fileUpload.uploadLogo') : t('fileUpload.logoPreview')}
            backFunc={() => {
              if (currentModalContentOption) {
                setModalContentOption(modalContentOptions.RENDER_ITEMMENU);
              }
              closePreviewDialog();
            }}
            closeFunc={null}
            renderActionButtonProps={
              !showUploadPanel
                ? {
                  title: t('fileUpload.continue'),
                  onClick: () => {
                    continueClick();
                  },
                  disabled: (userImages.length === 0 && !image),
                }
                : {
                  title: t('fileUpload.continue'),
                  onClick: () => {
                    uploadImage();
                  },
                  disabled: uploadDisabled,
                }
            }
          />
        );
      }
      return (
        <Dialog
          paperClassName={classes.dialogWrapper}
          open={open}
          onClose={closePreviewDialog}
          dialogTitle={showUploadPanel ? t('fileUpload.uploadLogo') : t('fileUpload.logoPreview')}
          maxWidth="lg"
          fullWidth
          fullScreen={!isWidthUp('sm', width)}
          scroll="paper"
        >
          {renderDialogContent()}
          <DialogActions className={classes.imageUploadSpacing}>
            {!showUploadPanel && (
            <MainButton
              onClick={continueClick}
              variant="contained"
              className={classes.PreviewDialogButton}
              disabled={userImages.length === 0 && !image}
              fullWidth={!isWidthUp('xs', width)}
            >
              {t('fileUpload.continue')}
            </MainButton>
            )}
            {showUploadPanel && (
            <MainButton
              fullWidth={!isWidthUp('xs', width)}
              onClick={uploadImage}
              variant="contained"
              className={classes.PreviewDialogButton}
              disabled={uploadDisabled}
            >
              {t('fileUpload.continue')}
            </MainButton>
            )}
          </DialogActions>
        </Dialog>
      );
    }
}

export default withStyles(styles, { name: 'ImageEditDialog' })(withWidth()(ImageEditDialog));
